<template>
  <div id="show_main" class="host-body">
    <div id="dv_header" class="header">
      <material-rack-header></material-rack-header>
    </div>
    <div id="dv_hr">
      <dv-decoration-5 class="dv_hr" />
    </div>
    <div id="left" class="left_silde">
      <left-side :req_url="url"></left-side>
    </div>
    <div class="right_silde">
      <right-side :req_url="materialUrl"></right-side>
    </div>
    <div class="content">
      <three-material-rack :cur_height="cur_height"> </three-material-rack>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import DataV from "@jiaminghi/data-view";
import MaterialRackHeader from "./DataV_Demo_MaterialRack_Header.vue";
import ThreeMaterialRack from "../../ThreeJS/ThreeJS_Products_MaterialRack_WithoutBg.vue";
import LeftSide from "./DataV_Demo_MaterialRack_Left_Side_New.vue";
//import LeftSide from "./DataV_Demo_MaterialRack_Number.vue";
import RightSide from "./DataV-Demo_MaterialRack_Right_Side.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(DataV);
Vue.use(ElementUI);

export default {
  components: {
    MaterialRackHeader,
    ThreeMaterialRack,
    LeftSide,
    RightSide,
  },
  data() {
    return {
      cur_height: 1000,
      url:
        "http://119.84.87.151:8082/Api/DataVSource/GetDataV?type=GetMaterialStockInfo",
      materialUrl:
        "http://119.84.87.151:8082/Api/DataVSource/GetDataV?type=MaterialMonitorInfo",
      materialTrendUrl:
        "http://119.84.87.151:8082/Api/DataVSource/GetDataV?type=MaterialTrend",
    };
  },
  beforeMount() {
  },
  mounted() {
    this.cur_height=this.getCurrHeight();
    window.addEventListener("resize", () => this.onWindowResize(), false);
  },
  methods: {
    getCurrHeight: function() {
      let left = document.getElementById("left"),
        header = document.getElementById("dv_header"),
        hr = document.getElementById("dv_hr");

      return left.clientHeight + header.clientHeight + hr.clientHeight;
    },
    onWindowResize: function() {
      this.cur_height = this.getCurrHeight();
      console.log(this.cur_height);
    },
  },
};
</script>
<style scoped>
.dv_hr {
  width: 100%;
  height: 40px;
  position: absolute;
  top: 50px;
  z-index: 10;
}

.bg {
  width: 100%;
  height: 100%;
}
.host-body {
  flex: 1;
  flex-direction: column;
  justify-content: space-around;
}

.header {
  position: absolute;
  width: 100%;
  height: 80px;
  flex: 2;
  z-index: 10;
}

.left_silde {
  width: 18%;
  position: absolute;
  z-index: 10;
  top: 8%;
}

.right_silde {
  width: 18%;
  position: absolute;
  z-index: 10;
  top: 8%;
  right: 5px;
}

.content {
  position: absolute;
  flex: 2;
  width: 99%;
  height: calc(100% - 80px);
}
</style>
